import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import ButtonArrow from "./ButtonArrow";

const useStyles = makeStyles((theme) => ({
  itemContainer: {
    marginLeft: "6em",
    marginBottom: "1.5em",
  },
}));

const WebsitePage = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography
          variant="h2"
          gutterBottom
          style={
            ({ marginLeft: matchesSM ? 0 : "5em" },
            { marginTop: "2em", marginLeft: "2em" })
          }
        >
          Website
        </Typography>
        <Typography
          variant="body1"
          paragraph
          style={
            ({ marginLeft: matchesSM ? 0 : "5em" },
            {
              marginTop: "2em",
              marginLeft: "4em",
              marginRight: "4em",
              marginBottom: "3em",
            })
          }
        >
          Our team of marketing strategists, designers, and developers build
          high converting websites that will bring immediate impact on your
          business
        </Typography>
      </Grid>
      <Grid item>
        <Grid container>
          <Grid item className={classes.itemContainer}>
            <ButtonArrow
              height={30}
              width={40}
              fill={theme.palette.common.blue}
            />
          </Grid>
          <Typography>Strategy & Consulting</Typography>
        </Grid>
        <Grid container>
          <Grid item className={classes.itemContainer}>
            <ButtonArrow
              height={30}
              width={40}
              fill={theme.palette.common.blue}
            />
          </Grid>
          <Typography>Creative Web Design</Typography>
        </Grid>
        <Grid container>
          <Grid item className={classes.itemContainer}>
            <ButtonArrow
              height={30}
              width={40}
              fill={theme.palette.common.blue}
            />
          </Grid>
          <Typography>Responsive Websites</Typography>
        </Grid>
        <Grid container>
          <Grid item className={classes.itemContainer}>
            <ButtonArrow
              height={30}
              width={40}
              fill={theme.palette.common.blue}
            />
          </Grid>
          <Typography>Content Management System</Typography>
        </Grid>
        <Grid container>
          <Grid item className={classes.itemContainer}>
            <ButtonArrow
              height={30}
              width={40}
              fill={theme.palette.common.blue}
            />
          </Grid>
          <Typography style={{ marginBottom: "20em" }}>E-Commerce</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WebsitePage;
